module.exports = __webpack_public_path__ + "img/c1.96877e4b.svg";